import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { riskComplianceBasePath } from './riskCompliancePaths';
import { useRiskComplianceErrorMessage } from './useRiskComplianceErrorMessage';

export const useInvestigateCustomerDunsHandler = (profileId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const getErrorMessage = useRiskComplianceErrorMessage();

  return useMutation({
    mutationFn: async ({ successMessage: _successMessage } = {}) => {
      const { data } = await apiClient.post(`${riskComplianceBasePath(profileId)}/investigate`);
      return data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customers', profileId, 'crif', 'risk-compliance'] });
      dispatch(
        showSnackbar({
          message: variables?.successMessage || 'D&B investigation initiated.',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
    },
  });
};
